<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="3"
            categoryName="Surface"
            categorySectionIcon="fa-bolt"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'surface',
    components: { BaseInventory }
}
</script>
